import React, { useState } from "react"
import { Button, ButtonGroup, Col, Dropdown, DropdownButton, Modal, Row } from "react-bootstrap";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";

import { AddSchoolModal } from "./"
import { Common } from "../../helper";
import { isEmptyArray, isEmptyObject } from "../../util";
import { errorMsg, success } from "../Shared";
import * as superAdminApi from "../../api/superAdminApi";

const SAAction = (props) => {
  const { schoolActionData, getSchoolDetails, activeStatus } = props;
  const [showModal, setShowModal] = useState()
  const [toViewSchool, setToViewSchool] = useState({});
  const [openViewModal, setOpenViewModal] = useState(false);
  const [school, setSchool] = useState()

  const handleDisableSchool = async () => {
    const allSchools = await superAdminApi.getSchoolById({ id: schoolActionData.id });
    if (!isEmptyObject(allSchools.Items)) {
      allSchools.Items.active = !allSchools.Items.active;
      const updateSchool = await superAdminApi.saveSchool(allSchools.Items);
      if (!isEmptyObject(updateSchool.Items)) {
        success("School Status Updated Successfully");
        getSchoolDetails();
      }
    }
  }
  const handleSchoolClick = () => {
    setToViewSchool(schoolActionData);
    setOpenViewModal(true);
  }
  const _inviteAdminUser = async () => {
    const getSchool = await superAdminApi.getSchoolById({ id: schoolActionData.id });
    let originUrl = window.location.origin;
    let user = {
      "verificationLink": `${originUrl}/NewUser`,
      "email": getSchool.Items.billingDetails.email,
      "type": 4,
      "schoolId": schoolActionData.id
    }
    const inviteAdmin = await superAdminApi.inviteAdminUser(user)
    if (isEmptyObject(inviteAdmin)) {
      errorMsg(Common.UnableToCreateAdmin)
    } else {
      success(Common.UserInvited)
    }
  }

  const getSchool = async (id) => {
    const school = await superAdminApi.getSchoolById({ id });
    if (!isEmptyObject(school.Items)) {
      setSchool(school)
    }
    else {
      setSchool({})
    }
    setShowModal(true);
  }

  return (
    <>
      <DropdownButton as={ButtonGroup} id="dropdown-variants-Secondary" title={Common.Actions}>
        <Button className="modal-button d-flex justify-content-start" type="button" onClick={handleSchoolClick}>&nbsp;{Common.ViewSchool}</Button>
        <Dropdown.Divider />
        <Button className="modal-button d-flex justify-content-start" type="button" onClick={() => { getSchool(schoolActionData.id) }}>
          <ModeEditOutlineOutlinedIcon />&nbsp;{Common.EditSchool}
        </Button>
        <Dropdown.Divider />
        <Button className="modal-button d-flex justify-content-start" type="button" onClick={_inviteAdminUser} >
          &nbsp;{Common.InviteUser}
        </Button>
        <Dropdown.Divider />
        <Button className="modal-button-danger d-flex justify-content-start" type="button" onClick={handleDisableSchool}>
          {activeStatus ? <><RemoveCircleOutlineOutlinedIcon />&nbsp;{Common.DisableSchool}</> : <span className="modal-button d-flex justify-content-start" type="button" >
            &nbsp;{Common.EnableSchool}
          </span>}
        </Button>
      </DropdownButton>
      {school && <AddSchoolModal showModal={showModal} setShowModal={setShowModal} isEdit={true} getSchoolDetails={getSchoolDetails} school={school} />}
      <Modal show={openViewModal} className="comment-modalOne">
        <Modal.Header className="viewSchoolHeader">
          <Col> <span className="d-flex justify-content-center align-items-center" >
            {toViewSchool.name}
          </span></Col>
        </Modal.Header>
        <Modal.Body className="addEvidenceModalBody">
          <Row>
            <div>
              <p>Contact Name: {`${toViewSchool?.billingDetails?.firstName} ${toViewSchool?.billingDetails?.lastName}`}</p>
              <p>Email: {toViewSchool.email}</p>
              <p>Address: {toViewSchool.address}</p>
              <p>Contact Number: {toViewSchool?.billingDetails?.phone}</p>
              <p>License Number: {toViewSchool?.billingDetails?.licenseNumber}</p>
              <p>Vat Number: {toViewSchool?.billingDetails?.vatNumber}</p>
              <span>Users: </span>
              {!isEmptyArray(toViewSchool.users) ? <ul>
                {toViewSchool?.users?.map((user, index) => (
                  <li key={index}>{user}</li>
                ))}
              </ul> : <span style={{ color: "red" }}>User yet to complete Signup</span>}

            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer className="comment-modal-footer">
          <button className="upload-cancel" type="button" onClick={() => setOpenViewModal(false)}>Close</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export { SAAction }
